import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['userConfig', 'useDarkMode'])
  },
  watch: {
    useDarkMode() {
      this.setSiteIcon();
    }
  },
  methods: {
    setSiteIcon() {
      const link = document.createElement('link');
      link.rel = 'icon';

      // 根据深色模式选择不同的 logo
      if (this.useDarkMode) {
        link.href = this.userConfig?.siteIcon || '/logo-dark.png';
      } else {
        link.href = this.userConfig?.siteIcon || '/logo.png';
      }
      document.head.appendChild(link);
    }
  }
};